import { CLAIMS_TOTAL_COUNTS_TYPES } from '@/contants/ClaimsEnums';
import { convertFromESTToLocal } from '@/utils/date/temporary';
import type { OverChargeClaim, OverChargeSearchFilters } from '@/views/screens/Claims/types';

import { CLAIMS_FOOTER_TYPES } from '../../constants';

interface OCClaimsListFooterData {
  closedClaim: number;
  filedAmount: number;
  holdClaim: number;
  openClaim: number;
  paidAmount: number;
  totalClaim: number;
  totalRecords: number;
}

export interface OCClaimsListResponse extends OCClaimsListFooterData {
  claimsData: OverChargeClaim[];
}

export const normalizeOCClaimsData = (data: any): OCClaimsListResponse => {
  const claimsData = (data?.item1 ?? data?.claimsData ?? []).map((claim: OverChargeClaim) => ({
    ...claim,
    ammendmentDate: convertFromESTToLocal(claim.ammendmentDate),
    closedDate: convertFromESTToLocal(claim.closedDate),
    dateSubmitted: convertFromESTToLocal(claim.dateSubmitted),
  }));

  const footerData = data?.item2 ?? data?.footerData ?? {};

  return {
    claimsData,
    closedClaim: footerData?.closedClaim ?? 0,
    filedAmount: footerData?.filedAmount ?? 0,
    holdClaim: footerData?.holdClaim ?? 0,
    openClaim: footerData?.openClaim ?? 0,
    paidAmount: footerData?.paidAmount ?? 0,
    totalClaim: footerData?.totalClaim ?? 0,
    totalRecords: footerData?.totalRecords ?? footerData?.totalClaim ?? 0,
  };
};

export const getFooterCountParam = (footerStatus: OverChargeSearchFilters['FooterStatus']) => {
  return CLAIMS_TOTAL_COUNTS_TYPES[footerStatus] === CLAIMS_TOTAL_COUNTS_TYPES[CLAIMS_FOOTER_TYPES.ALL]
    ? CLAIMS_TOTAL_COUNTS_TYPES.ALL_FOR_OC_CLAIM
    : CLAIMS_TOTAL_COUNTS_TYPES[footerStatus];
};
